<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    {{lableText('TaskType')??'نوع وظیفه'}}
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2 p-3">
                <div class="search-box search-color bg-magenta1-light rounded-sm w-100">
                    <i class="fa fa-search"></i>
                    <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                </div>
            </div>
            <div class="card card-style mb-2">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="list-group-div p-2" @click.prevent="openDetails(task.taskTypeId)" v-for="task in TaskTypeList" :key="task.taskTypeId">
                        <div class="py-3">
                            <i class="fa fa-check-circle color-blue2-dark"></i>
                            <span class="font-weight-bold">{{task.title}}</span>
                            <span class="float-left" @click.stop="showMenu(task.taskTypeId)" width="60px"><i class="fa fa-ellipsis-v float-left ml-0 font-14"></i></span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="TaskTypeList.length==0 && Loading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">هیچ موردی یافت نشد.</p>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/CreateTaskType" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CreateTaskType', params: { taskTypeId: selectedTypeId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>ویرایش</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="deleteTaskType" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>
        <!--<div id="taskTypeHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
        <div class="position-relative">
            <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
            <div class="card" data-card-height="90">
                <div class="card-top">
                    <div class="page-title page-title-small">
                        <h2 class="text-center">راهنمای نوع وظیفه</h2>
                    </div>
                </div>
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mt-0 pb-2">
                    <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                        <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                            <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                            <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                            <i class="fa fa-angle-down line-height-xl"></i>
                        </div>
                    </div>
                    <div class="collapse border-b pb-3" id="collapse-0" style="">
                        <div class="d-flex justify-content-center">
                            <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskType.mp4" type="video/mp4">
                            </video>
                        </div>
                        <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                    </div>
                    <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                        <div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
                            <i class="fa fa-check-circle color-blue2-dark font-14"></i>
                            <span class="font-14">راهنمای نوع وظیفه</span>
                            <i class="fa fa-angle-down line-height-xl"></i>
                        </div>
                    </div>
                    <div class="collapse border-b pb-3" id="collapse-1" style="">
                        <div class="d-flex justify-content-center">
                            <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" type="video/mp4">
                            </video>
                        </div>
                        <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                pageTitle: "",
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                pageLoaded: false
            };
        },
        computed: {
            TaskTypeList() {
                return this.$store.getters.GetTaskTypeListForEdit;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },

        created() {
            this.pageTitle = "راهنمای " + (this.lableText('TaskType') ?? 'نوع وظیفه');
            this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;
               
            },
            showMenu(taskTypeId) {
                this.selectedTypeId = taskTypeId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            deleteTaskType() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این نوع  هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Task/DeleteTaskType?id=" + this.selectedTypeId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(taskTypeId) {
                this.$router.push({ name: 'CreateTaskType', params: { taskTypeId: taskTypeId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForTaskTypeList() {
                this.page++;
                this.$store.dispatch("GetTaskTypeListForEditFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        mounted() {
            console.log("mounted");
            this.showAddButton();
            this.getNextPageForTaskTypeList();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

        }
    };
</script>
